export const createPersonWithId = (row, titleRow, makeId) => {
  const sendData = row.map((r => titleRow.map((item, index) => (item && item.name ? { [item.name]: r[index].value, id: r[index].id } : null))));
  sendData.filter(obj => obj);
  const sendDataWithId = [];
  sendData.map((obj, i) => {
    const o = obj;
    o.id = row[i].id;
    sendDataWithId.id = `${row[i].id}-${i}`;
    return sendDataWithId.push(o);
  });
  const ageExist = titleRow.some(item => item && item.name === 'age');
  if (ageExist) {
    const getAges = sendDataWithId.map(data => data && data.filter(d => d && d.age)[0].age);
    const countAges = {};
    if (getAges) {
      getAges.forEach((x) => { countAges[x] = (countAges[x] || 0) + 1; });
    }
    countAges.id = makeId;
    sendDataWithId.ages = countAges;
  }
  return sendDataWithId;
};



// WEBPACK FOOTER //
// ./src/components/organisms/ImportFile/steps/cabin/createPersonWithId.js